// extracted by mini-css-extract-plugin
export default {"title":"_327b17f649","bld":"_3da7bf11a2"};